export default __webpack_public_path__ + "static/media/qa-tab.78f712e3.png";